import { $api } from "@/kibi/core/utils/api";
import type { InjectionKey } from "vue";
import type { DashboardResponseDTO } from "../models/dashboard_model";

export interface DashboardDataSource {
  getDashboardData(): Promise<DashboardResponseDTO>;
}

export const dashboardDataSourceKey: InjectionKey<DashboardDataSource> =
  Symbol("DashboardDataSource");

export class DashboardDataSourceImpl implements DashboardDataSource {
  async getDashboardData(): Promise<DashboardResponseDTO> {
    const response = await $api<{
      message: string;
      data: DashboardResponseDTO;
    }>("/dashboard", {
      method: "GET",
    });
    return response.data;
  }
}
